import React from 'react';

import { insights } from './MobileStreamingAnalysis.module.sass';

const Insights = () => <div className={insights} />;

export default Insights;
